import {
  autocomplete,
  search,
} from '@nosto/autocomplete';
import '@nosto/autocomplete/styles.css';
import autocompleteTemplate from './autocomplete-template';
import formatProductsData from '../nosto/format-products-data-nosto';
import fieldsRequest from '../../components/nosto/fields-request';
import NostoCollections from '../../components/nosto/collections';
// import applyShopifyMarket from '../nosto/applyShopifyMarket';
import { selectSwatch, getTileInitialSwatch } from '../../sections/collection/selectNewColor';
import FullSearch from './full-search';
import scrollToTop from './scroll';

export default class SuggestionsSearch {
  max_search_suggestions;
  max_suggested_results;
  min_search_chars;
  elements;
  is_keyword_selected;
  autocomplete_div_id;
  fullSearch;
  NostoRecommendationsInstance;

  constructor(NostoRecommendationsInstance) {
    this.NostoRecommendationsInstance = NostoRecommendationsInstance;
    this.max_search_suggestions = window.theme.search.max_search_suggestions ?? 4; // 4 search (keywords) suggestions
    this.max_suggested_results = window.theme.search.max_suggested_results ?? 6; // 6 product suggestions
    this.min_search_chars = window.theme.search.min_query_length ?? 3; // 3+ to allow small words like "red"
    this.is_keyword_selected = false; // When true, we just show the first 6 products
    this.autocomplete_div_id = 'search-results';

    this.elements = {
      nostoForm: document.getElementById('search-form'),
      searchInput: document.getElementById('search'),
      clearSearchButton: document.querySelector('.nosto-form__clear-button'),
      searchResultsContainer: document.querySelector('[data-overlay-search-autocomplete-results]'),
      searchResults: document.getElementById(this.autocomplete_div_id),
    };

    this.fullSearch = new FullSearch();

    // this.initEvents();
  }

  triggerSearchInput = () => {
    const enterEvent = new KeyboardEvent('keydown', {
      key: 'Enter',
      code: 'Enter',
      keyCode: 13,
      which: 13,
      bubbles: true,
      cancelable: true
    });
    this.elements.searchInput.dispatchEvent(enterEvent);
  };

  initEvents = () => {
    document.addEventListener('click', (event) => {
      // The "See all results" button is outside the form, we submit the form by triggering the Enter key
      if (event.target.closest('[astr-autocomplete-see-all]')) {
        this.triggerSearchInput();
      }

      if (event.target.closest('.ns-autocomplete-keyword')) {
        event.stopPropagation();
        event.preventDefault();

        const hit_element = event.target.closest('.ns-autocomplete-keyword');
        const hit_data = JSON.parse(hit_element.dataset.nsHit);
        this.elements.searchInput.value = hit_data.keyword;
        this.elements.searchInput.focus();
        this.is_keyword_selected = true;
        this.triggerSearchInput();
      }
    });

    // Reset the autocomplete results, input is cleared automatically
    if (this.elements.clearSearchButton) {
      this.elements.clearSearchButton.addEventListener('click', () => {
        if (this.elements.searchInput) {
          this.elements.searchInput.value = '';
          this.elements.searchInput.dispatchEvent(new Event('input', { bubbles: true }));
        }

        this.elements.searchResults.innerHTML = '';
      });
    }

    // Handle both desktop and mobile navigation, triggered from full-search.js
    document.addEventListener('astr-nosto-pagination', async (e) => {
      await this.nostoSearch(true);
    });

    document.addEventListener('astr-nosto-no-search-results-recommendations-loaded', (e) => {
      this.populateNoResults();
    });
  };

  noResults = () => {
    console.log('No search results found, load the backup products');
    this.elements.searchResults.parentElement.classList.remove('hidden');
    this.elements.searchResults.classList.add('no-results');

    // https://my.nosto.com/admin/shopify-24836632/campaigns/placements/6014769460b2b98d365d7576

    // <div class="ns-autocomplete-products-list" ></div> Will be removed
    // <div id="searchpage-nosto-1" class="ns-autocomplete-products-list nosto_element nosto_dynamic_element" >
    // <!-- nosto campaign ->
    // </div>

    // this.elements.searchResults.innerHTML = `
    //   <div class="ns-autocomplete-results" data-nosto-recommendations>
    //     <h4>No products for this query but here are some products you may like:</h4>
    //     <section class="ns-autocomplete-products">
    //       <div class="ns-autocomplete-products-list"></div>
    //     </section>
    //   </div>
    // `;

    this.elements.searchResults.innerHTML = `
      <div class="ns-autocomplete-results" data-nosto-recommendations>
        <h4>${window.theme.strings.noResults}</h4>
        <section class="ns-autocomplete-products">
          <div id="${window.theme.search.nosto_search_no_results_placement}" class="ns-autocomplete-products-list nosto_element nosto_dynamic_element"></div>
        </section>
      </div>
    `;

    if (window.theme.search.nosto_search_no_results === null) {
      this.NostoRecommendationsInstance.loadDynamicRecommendation(window.theme.search.nosto_search_no_results_placement);
    } else {
      this.populateNoResults();
    }

    scrollToTop('instant');
  };

  populateNoResults = () => {
    if (window.theme.search.nosto_search_no_results === null) {
      return;
    }

    // It's possible the response is response.products[] instead of response.products.hits[]
    if (typeof window.theme.search.nosto_search_no_results?.products?.hits === 'undefined' && typeof window.theme.search.nosto_search_no_results?.products !== 'undefined') {
      window.theme.search.nosto_search_no_results.products = {
        hits: window.theme.search.nosto_search_no_results?.products,
      };
    }

    const products_container = document.querySelector('.ns-autocomplete-products');
    const products_html = autocompleteTemplate(window.theme.search.nosto_search_no_results, true, false);
    products_container.innerHTML = products_html;

    // Set the result_id for event tracking
    const product_list = products_container.querySelector('.ns-autocomplete-products-list');
    if (!product_list) {
      console.warn('[ASTR] No products list found in the no results container.');
      return;
    }

    product_list.dataset.resultId = window.theme.search.nosto_search_no_results?.result_id;

    // Select the recommended color, or the first one as a fallback
    product_list.querySelectorAll('[data-product-tile]').forEach((product_tile) => {
      const swatch = getTileInitialSwatch(product_tile);
      if (swatch) {
        selectSwatch(swatch);
      }
    });

    return;
  };

  /*
  * Full search request to Nosto
  * 
  * @param {boolean} filter_or_sorting_selected - When true, we're coming from the filtering or sorting
  */
  nostoSearch = async (filter_or_sorting_selected = false) => {
    if (window.theme.search.query.length < window.theme.search.nosto_search_config.minQueryLength) {
      return;
    }

    if (!this.is_keyword_selected & !filter_or_sorting_selected) {
      this.fullSearch.resetSearchElements();
    }

    let filters = [];
    let sorting = [];

    // Prepare the screen for the new full search when we're not coming from the keywords
    if (!this.is_keyword_selected || filter_or_sorting_selected) {
      const NostoCollectionsInstance = new NostoCollections();

      // Sorting defined in sections/collection/sorting.js
      sorting = NostoCollectionsInstance.getSortConfig();

      if (window.theme.search?.filtering !== 'undefined' && window.theme.search?.filtering.length > 0) {
        filters = NostoCollectionsInstance.transformFilters(window.theme.search?.filtering);
      }
    }

    const from_page = (this.is_keyword_selected) ? 0 : (Number(window.theme.search.products_per_page) * (window.theme.search.page - 1)) ?? 0;

    // https://search.nosto.com/v1/graphql?ref=InputSearchQuery
    // https://my.nosto.com/admin/shopify-24836632/search/settings/indexedFields
    const search_query = {
      // currency: window.theme.currency_cart, // this works but not perfect as the currencies in Nosto and Shopify might not be fully synced, so we just request the USD prices and then convert within the product tile template
      fields: fieldsRequest,
      size: (this.is_keyword_selected) ? this.max_suggested_results : Number(window.theme.search.products_per_page),
      from: from_page,
      facets: ['*'],
    };

    if (sorting.length > 0) {
      search_query.sort = sorting;
    }

    // Exclude combined listing parents (combined_product is only set to 'true' on those parents, otherwise unset)
    filters.push({
      'not': [
        { 'field': 'customFields.astr-combined_product', 'value': ['true'] }
      ]
    });

    // Hide ambassador products unless the current customer is an ambassador
    if (!window.theme.customer.ambassador) {
      filters.push({
        'not': [
          { 'field': 'tags1', 'value': ['AMBASSADOR', 'Ambassador', 'ambassador'] }
        ]
      });
    }

    search_query.filter = filters;

    console.log('[ASTR] Full search query', search_query);

    const search_response = await search({
      query: window.theme.search.query,
      products: search_query
    }, {
      redirect: true,
      track: window.theme.search.nosto_search_config.nostoAnalytics ? 'serp' : undefined,
      ...window.theme.search.nosto_search_options
    }
    );

    console.log('[ASTR] Search response', search_response);

    const formatted_response = formatProductsData(search_response.response);

    // When coming from the keywords
    if (this.is_keyword_selected) {
      this.is_keyword_selected = false;

      // Hide the selected keyword and show the others
      document.querySelectorAll('.ns-autocomplete-keyword').forEach((keyword_element) => {
        const hit_data = JSON.parse(keyword_element.dataset.nsHit);

        keyword_element.classList.remove('hidden');
        if (this.elements.searchInput.value.toLowerCase() === hit_data.keyword.toLowerCase()) {
          keyword_element.classList.add('hidden');
        }
      });

      // We show the no results content when there are no products available
      if (
        (typeof search_response !== 'undefined' && search_response?.response?.products?.hits.length === 0) ||
        typeof search_response === 'undefined' || search_response?.response?.products?.hits.length === 0
      ) {
        this.noResults();
        return;
      }

      // we use the first 6 products and do the same as autocomplete

      const products_container = document.querySelector('.ns-autocomplete-products');
      const products_html = autocompleteTemplate(formatted_response, (products_container !== null));

      if (products_container) {
        products_container.innerHTML = products_html;
      } else {
        this.elements.searchResults.innerHTML = products_html;
      }

      // Select the recommended color, or the first one as a fallback
      document.querySelectorAll('.ns-autocomplete-products-list [data-product-tile]').forEach((product_tile) => {
        const swatch = getTileInitialSwatch(product_tile);
        if (swatch) {
          selectSwatch(swatch);
        }
      });

      // Avoid some flickering effect when products from previous requests are still visible
      // window.setTimeout(() => {
      //   animateNoScroll(document.querySelector('.ns-autocomplete-products'));
      // }, 150);

      return;
    }

    // Starting here, we're coming from the full search
    if (window.theme.search.page === 1) {
      this.elements.searchResultsContainer.classList.add('hidden');
      this.elements.searchResultsContainer.setAttribute('aria-expanded', 'false');
      document.querySelector('.overlay-search__autocomplete')?.setAttribute('aria-expanded', 'false');
      this.elements.searchResults.innerHTML = '';
      this.fullSearch.fullSearchPerformed(formatted_response);
    } else {
      this.fullSearch.pagedSearchPerformed(formatted_response);
    }

    this.elements.searchInput.blur();
  };

  getAutocompleteSuggestions = () => {
    // https://nosto.github.io/nosto-autocomplete/interfaces/._.AutocompleteConfig.html
    autocomplete({
      inputSelector: '#search',
      dropdownSelector: `#${this.autocomplete_div_id}`,
      historyEnabled: false,
      minQueryLength: this.min_search_chars,
      fetch: {
        products: {
          fields: fieldsRequest,
          size: this.max_suggested_results,
          // Exclude combined listing parents (combined_product is only set to 'true' on those parents, otherwise unset)
          // Hide ambassador products unless the current customer is an ambassador
          filter: [
            {
              'not': [
                { 'field': 'customFields.astr-combined_product', 'value': ['true'] },
                ...(!window.theme.customer.ambassador ? [{ 'field': 'tags1', 'value': ['AMBASSADOR', 'Ambassador', 'ambassador'] }] : [])
              ]
            }
          ],
        },
        keywords: {
          size: this.max_search_suggestions,
          fields: ['keyword', '_highlight.keyword'],
          highlight: {
            preTag: `<strong>`,
            postTag: '</strong>'
          }
        },
      },
      // render: fromLiquidTemplate(defaultLiquidTemplate), // https://github.com/Nosto/nosto-autocomplete/blob/main/src/defaults/autocomplete.liquid
      // render: fromLiquidTemplate(autocompleteTemplate),
      // render: fromRemoteLiquidTemplate(liquidTemplate),
      render: (container, state) => { // https://nosto.github.io/nosto-autocomplete/functions/._.autocomplete.html
        // Fix a bug when suggestion results are available from another search and the new search has not the required chracters count
        if (this.elements.searchInput.value.length < this.min_search_chars) {
          return;
        }

        this.elements.searchResults.classList.remove('no-results');

        // Reset the full search elements
        document.querySelector('[data-overlay-search]').classList.remove('results-visible');
        this.elements.searchResultsContainer.setAttribute('aria-expanded', 'true');
        document.querySelector('.overlay-search__autocomplete')?.setAttribute('aria-expanded', 'true');

        this.fullSearch.resetSearchElements();

        if ((typeof state.response !== 'undefined' && state?.response?.query.length >= this.min_search_chars && state?.response?.products?.hits.length === 0)) {
          this.noResults();
          this.elements.searchResultsContainer.classList.remove('hidden');
          return;
        }

        // Do not show the no results message from there
        if (typeof state.response === 'undefined' || state?.response?.products?.hits.length === 0) {
          return;
        }

        // Handle redirects if not already on the destination page
        if (state.response.redirect && !window.location.href.includes(state.response.redirect)) {
          let search_redirect_url = state.response.redirect;
          // Find out if the redirect includes the country and language option such as https://www.astrthelabel.com/en-fr/
          // Extract locale path if present (e.g., /en-CA/, /fr-CA/, /en-FR/)
          const locale_pathname_match = window.location.pathname.match(/^\/([a-z]{2}-[A-Z]{2}|[a-z]{2}-[a-z]{2}|[a-z]{2}-[A-Z]{2}|[a-z]{2}-[a-z]{2})/);
          const locale_pathname = locale_pathname_match ? locale_pathname_match[0] : '';
          if (locale_pathname !== '') {
            const locale_match = search_redirect_url.match(/^\/([a-z]{2}-[A-Z]{2}|[a-z]{2}-[a-z]{2}|[a-z]{2}-[A-Z]{2}|[a-z]{2}-[a-z]{2})/);
            const locale_path = locale_match ? locale_match[0] : '';

            // The redirect is missing the locale path, we need to add it
            if (locale_path === '') {
              search_redirect_url = `${locale_pathname}${search_redirect_url.replace(window.location.origin, '')}`;
            }
          }

          window.location.href = search_redirect_url;
          return;
        }

        this.elements.searchResultsContainer.classList.remove('hidden');
        const formatted_products = formatProductsData(state?.response);
        container.innerHTML = autocompleteTemplate(formatted_products);

        document.querySelectorAll('.ns-autocomplete-products-list [data-product-tile]').forEach((product_tile) => {
          // Select the recommended color swatch, or the first one as a fallback
          const initial_swatch = getTileInitialSwatch(product_tile);
          if (initial_swatch) {
            selectSwatch(initial_swatch);
          }

          // Prevent Nosto from taking over the click/touch events
          // We need to manually handle the click and touchend events since stopPropagation will also prevent our click event from being triggered
          product_tile.addEventListener('click', (e) => {
            e.stopPropagation();

            if (e.target.closest('[data-color-swatch]')) {
              selectSwatch(e.target.closest('[data-color-swatch]'));
              return;
            }
          });
          product_tile.addEventListener('touchend', (e) => {
            e.stopPropagation();

            if (e.target.closest('[data-color-swatch]')) {
              selectSwatch(e.target.closest('[data-color-swatch]'));
              return;
            }
          });
        });

        // Avoid some flickering effect when products from previous requests are still visible
        // window.setTimeout(() => {
        //   animateNoScroll(document.querySelector('.ns-autocomplete-products'));
        // }, 150);

        scrollToTop('instant');

        // applyShopifyMarket('[data-overlay-search-autocomplete-results]');
      },
      submit: async (query, config, options) => {
        window.theme.search.query = query;
        window.theme.search.nosto_search_config = config;
        window.theme.search.nosto_search_options = options;

        await this.nostoSearch();
      },
    });
  };
}
